import React, { Component } from "react";
import PopUpForm from "../../../Generic/PopUpDialog/PopUpForm";
import { connect } from "react-redux";
import { API } from "aws-amplify";
import * as VALIDATIONTYPES from "../../../Generic/validationTypes";
import { setRefresh } from "../../../../actions/algoliaActions";
import { setAlgoliaLoaderState } from "../../../../actions/loaderActions";

class CreateBlindKassettePopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationTypes: VALIDATIONTYPES.blindDoubleBracketSystem
    };
  }
  handleCancelClick = () => {
    this.props.history.goBack();
  };

  APIMethod = async formData => {
    try {
      this.props.dispatch(setAlgoliaLoaderState(true));
      const body = {
        details: {
          name: formData.name,
          cost: formData.cost,
          markup: formData.markup,
          associatedServices: formData.associatedServices,
          manufacturerId: formData.manufacturerId
        }
      };
      this.props.history.push(`/products/blinds/double-bracket-system`);
      await API.post("telishadeAPI", "/product/blind/component/double-bracket-system", {
        body
      });
      this.props.dispatch(setAlgoliaLoaderState(false));
      this.props.dispatch(setRefresh(true));
    } catch (e) {
      this.props.dispatch(setAlgoliaLoaderState(false));
      throw e;
    } finally {
      // Refresh any algolia components currently mounted 1 second after updating
      setTimeout(() => {
        this.props.dispatch(setRefresh(false));
        this.props.dispatch(setRefresh(true));
        this.props.dispatch(setRefresh(false));
      }, 0);
    }
  };

  render() {
    return (
      <PopUpForm
        fields={this.state.validationTypes}
        apiMethod={this.APIMethod}
        header="Add New Blind Double Bracket System"
        button="Accept"
        buttoncolour="green"
        button2="Cancel"
        button2colour="red"
      />
    );
  }
}

export default connect()(CreateBlindKassettePopUp);
